/* eslint-disable */

import { rootApi } from '../rootApi';

export const announcementTypeApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAnnouncementTypeAll: builder.query({
            query: ({ pageNumber, pageSize, type ,languageId 

            }) => {
                const queryParams = {
                    PageNumber: pageNumber !== undefined ? pageNumber : 0,
                    PageSize: pageSize || 10
                };
               if (type) {
                    queryParams.type = type;
                }
               if (languageId) {
            queryParams.LanguageId = languageId;
        }

                return {
                    url: 'v1/announcementType/getall',
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.items)) {
                        return response.data;
                    }
                    if (Array.isArray(response.items)) {
                        return response;
                    }
                }
                return { items: [], totalCount: 0 };
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {}
            },
            providesTags: ['AnnouncementType']
        }),

        GetAnnouncementTypeById: builder.query({
            query: (id) => {
                return `v1/announcementType/${id}`;
            },
            transformResponse: (response) => {
                return response?.data || null;
            },
            providesTags: (result, error, id) => [{ type: 'AnnouncementType', id }]
        }),

        createAnnouncementTypeAsync: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/announcementType/create',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: ['AnnouncementType']
        }),

        UpdateAnnouncementType: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/announcementType/update',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: (result, error, { id }) => [{ type: 'AnnouncementType', id }]
        }),

        DeleteAnnouncementType: builder.mutation({
            query: (id) => {
                return {
                    url: `v1/announcementType/delete`,
                    method: 'DELETE',
                    body: { id }
                };
            },
            invalidatesTags: ['AnnouncementType']
        }),

AnnouncementTypeDropdown: builder.query({
  query: (params = {}) => {
    const queryParams = {};
    
    if (params?.type != null && params.type !== '') {
      queryParams.Type = params.type;
    }
    
    if (params?.languageId != null) {
      queryParams.LanguageId = params.languageId;
    }
    
    return { 
      url: 'v1/announcementType/gettypedropdown',
      method: 'GET',
      params: queryParams
    };
  },
  transformResponse: (response) => {
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(response)) return response;
    return [];
  },
  providesTags: [{ type: 'AnnouncementType', id: 'DROPDOWN' }],
}),


  }),
});

export const {
    useGetAnnouncementTypeAllQuery,
    useGetAnnouncementTypeByIdQuery,
    useCreateAnnouncementTypeAsyncMutation,
    useUpdateAnnouncementTypeMutation,
    useDeleteAnnouncementTypeMutation,
    useAnnouncementTypeDropdownQuery
} = announcementTypeApi;
